import Qt from "./custom-event-data.js";
import Yt from "./custom-event-property-data.js";
import Wt from "./filter-set.js";
import si from "./in-app-message-click-data.js";
import rs from "./purchase-data.js";
import is from "./purchase-property-data.js";
import sr from "./push-click-data.js";
import tt from "./trigger-events.js";
import r from "../../../shared-lib/braze-shared-lib.js";
import { getErrorMessage as ei } from "../../util/error-utils.js";
export default class ri {
  constructor(e, t) {
    (this.type = e), (this.data = t), (this.type = e), (this.data = t);
  }
  ec(e, t) {
    return ri.rc[this.type] === e && (null == this.data || this.data.Bl(t));
  }
  static Bu(e, t) {
    let s = null;
    try {
      s = window.atob(e);
    } catch (t) {
      return (
        r.j.info("Failed to unencode analytics id " + e + ": " + ei(t)), !1
      );
    }
    return t === s.split("_")[0];
  }
  static fromJson(e) {
    const t = e.type;
    let r = null;
    switch (t) {
      case ri.Wr.OPEN:
      case ri.Wr.vt:
        break;
      case ri.Wr.Rr:
        r = rs.fromJson(e.data);
        break;
      case ri.Wr.sc:
        r = is.fromJson(e.data);
        break;
      case ri.Wr.zr:
        r = sr.fromJson(e.data);
        break;
      case ri.Wr.$e:
        r = Qt.fromJson(e.data);
        break;
      case ri.Wr.ac:
        r = Yt.fromJson(e.data);
        break;
      case ri.Wr.ro:
        r = si.fromJson(e.data);
    }
    return new ri(t, r);
  }
  tt() {
    return { t: this.type, d: this.data ? this.data.tt() : null };
  }
  static Yn(e) {
    let t,
      r = null;
    switch (e.t) {
      case ri.Wr.OPEN:
      case ri.Wr.vt:
        break;
      case ri.Wr.Rr:
        r = new rs(e.d);
        break;
      case ri.Wr.sc:
        (t = e.d || {}), (r = new is(t.id, Wt.Yn(t.pf || [])));
        break;
      case ri.Wr.zr:
        r = new sr(e.d);
        break;
      case ri.Wr.$e:
        r = new Qt(e.d);
        break;
      case ri.Wr.ac:
        (t = e.d || {}), (r = new Yt(t.e, Wt.Yn(t.pf || [])));
        break;
      case ri.Wr.ro:
        r = new si(e.d);
    }
    return new ri(e.t, r);
  }
}
(ri.Wr = {
  OPEN: "open",
  Rr: "purchase",
  sc: "purchase_property",
  zr: "push_click",
  $e: "custom_event",
  ac: "custom_event_property",
  ro: "iam_click",
  vt: "test",
}),
  (ri.rc = {}),
  (ri.rc[ri.Wr.OPEN] = tt.OPEN),
  (ri.rc[ri.Wr.Rr] = tt.Rr),
  (ri.rc[ri.Wr.sc] = tt.Rr),
  (ri.rc[ri.Wr.zr] = tt.zr),
  (ri.rc[ri.Wr.$e] = tt.$e),
  (ri.rc[ri.Wr.ac] = tt.$e),
  (ri.rc[ri.Wr.ro] = tt.ro),
  (ri.rc[ri.Wr.vt] = tt.vt);
